<script>
  import { createEventDispatcher } from 'svelte';
  import Logo from "../shared/Logo.svelte";
  export let activeView;
  export let baseSystem;

  const dispatch = createEventDispatcher();
  const options = ['Base System', 'Picker Options', 'Additional Options', 'Purchase Options'];
</script>

<style>
  header {
    background: linear-gradient(177.21deg, #005397 0.77%, #00467f 76.64%);
  }

  .menu {
      font-family: Camphor W01 Bold;
  }
  
  .tab {
    @apply mx-6 border-b-4 border-transparent py-6 opacity-50 transition duration-300 ease-in;
  }

  .tab:last-child {
    @apply mr-2;
  }

  .active {
    @apply border-white opacity-100;
  }
</style>

<div class="w-full">
  <header class="flex items-center py-4 px-8 lg:py-0">
    <div class="w-1/3">
      <div class="flex items-center">
        <Logo />
        <span
          class="hidden lg:inline-block text-white lg:text-base xl:text-2xl border-l border-white
          border-opacity-25 ml-6 pl-6">
          Build my Verso Q20
        </span>
      </div>

    </div>
    <div class="w-2/3 text-right text-white">
      <span class="lg:hidden">Q20 Configurator</span>

      <span class="menu hidden lg:flex justify-end items-stretch text-sm">
        {#each options as option}
        
          {#if baseSystem !== 'Plate Store' || option !== 'Picker Options'}
            {#if options.indexOf(option) < options.indexOf(activeView)}
              <button class="tab" class:active={option === activeView} on:click={() => dispatch('handleStepBack', {stepName: options.indexOf(option)})}>
                {option}
              </button>
            {:else}
              <div class="tab" class:active={option === activeView}>
                {option}
              </div>
            {/if}
          {/if}
          
        {/each}
      </span>
    </div>
  </header>
</div>
